import { lazy } from "react";
import CreateCommunityForum from "../components/admin/Forum/CreateCommunityForum";
import AddPublication from "../components/admin/ManageContent/AddPublication";
import ContentView from "../components/admin/ManageContent/ContentView";
import ViewCsoDetails from "../components/admin/ManageCso/ViewCsoDetails";
import AddCampaigns from "../components/admin/ManageEvents/AddCampaigns";
import AddEvents from "../components/admin/ManageEvents/AddEvents";
import AddWebinars from "../components/admin/ManageEvents/AddWebinars";
import AddTrainingMaterial from "../components/admin/ManageTraining/AddTrainingMaterial";
import TrainingMaterialView from "../components/admin/ManageTraining/TrainingMaterialView";
import ForumDetails from "../pages/admin/CommunityForum/ForumDetails";
import AllContent from "../pages/admin/ContentManagement/AllContent";
import ContentCategory from "../pages/admin/ContentManagement/ContentCategory";
import DiscusPendingRequests from "../pages/admin/DiscussionBoard/DiscusPendingRequests";
import DiscussionDetails from "../pages/admin/DiscussionBoard/DiscussionDetails";
import PendingRequestViewDetails from "../pages/admin/DiscussionBoard/PendingRequestViewDetails";
import Campaigns from "../pages/admin/EventManage/Campaigns";
import PendingRequests from "../pages/admin/EventManage/PendingRequests";
import { RouteType } from "../types";

const NotFound = lazy(() => import("../pages/NotFound"));
const AdminLogin = lazy(() => import("../pages/admin/Login"));
const AdminDashboard = lazy(() => import("../pages/admin/Dashboard"));
const websiteCms = lazy(() => import("../pages/admin/website/websiteCms"));
const TrainingMaterial = lazy(
  () => import("../pages/admin/Training/TrainingMaterial")
);
const TrainingCategory = lazy(
  () => import("../pages/admin/Training/TrainingCategory")
);
const Settings = lazy(() => import("../pages/admin/Settings/Settings"));
const RegionalHub = lazy(() => import("../pages/admin/Region/RegionalHub"));
const Division = lazy(() => import("../pages/admin/Region/Division"));
const District = lazy(() => import("../pages/admin/Region/District"));
const Notifications = lazy(
  () => import("../pages/admin/Notification/Notifications")
);
const LiveMessaging = lazy(
  () => import("../pages/admin/Messaging/LiveMessaging")
);
const Webinars = lazy(() => import("../pages/admin/EventManage/Webinars"));
const Events = lazy(() => import("../pages/admin/EventManage/Events"));
const DonationManage = lazy(
  () => import("../pages/admin/Donation/DonationManage")
);
const DiscussionList = lazy(
  () => import("../pages/admin/DiscussionBoard/DiscussionList")
);
const CategoryBoard = lazy(
  () => import("../pages/admin/DiscussionBoard/CategoryBoard")
);
const UserList = lazy(() => import("../pages/admin/cso/UserList"));
const RoleCreate = lazy(() => import("../pages/admin/cso/RoleCreate"));
const TopicCategory = lazy(
  () => import("../pages/admin/CommunityForum/TopicCategory")
);
const Forum = lazy(() => import("../pages/admin/CommunityForum/Forum"));

// auth routers
export const sidebarRouters: RouteType[] = [
  {
    path: "/admin/dashboard",
    element: AdminDashboard,
    roles: ["ADMIN"],
  },
  //CSO
  {
    path: "/admin/cso-manager/user-list",
    element: UserList,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/cso-manager/user-list/:id",
    element: ViewCsoDetails,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/cso-manager/role-create",
    element: RoleCreate,
    roles: ["ADMIN"],
  },
  // EVENT
  {
    path: "/admin/event-manage/events",
    element: Events,
    roles: ["ADMIN"],
  },

  {
    path: "/admin/event-manage/events/add-events",
    element: AddEvents,
    roles: ["ADMIN"],
  },

  {
    path: "/admin/event-manage/events/:id",
    element: AddEvents,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/event-manage/webinars",
    element: Webinars,
    roles: ["ADMIN"],
  },

  {
    path: "/admin/event-manage/webinars/add-webinars",
    element: AddWebinars,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/event-manage/webinars/add-webinars/:id",
    element: AddWebinars,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/event-manage/pending-request",
    element: PendingRequests,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/event-manage/campaigns",
    element: Campaigns,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/event-manage/campaigns/add-campaigns",
    element: AddCampaigns,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/event-manage/campaigns/add-campaigns/:id",
    element: AddCampaigns,
    roles: ["ADMIN"],
  },

  //content
  {
    path: "/admin/content-manage/content",
    element: AllContent,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/content-manage/content/add-publication",
    element: AddPublication,
    roles: ["ADMIN"],
  },

  {
    path: "/admin/content-manage/content/add-publication/:id",
    element: AddPublication,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/content-manage/content/content-view/:id",
    element: ContentView,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/content-manage/category",
    element: ContentCategory,
    roles: ["ADMIN"],
  },

  //FORUM
  {
    path: "/admin/community-forum/forum",
    element: Forum,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/community-forum/forum/:id",
    element: ForumDetails,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/community-forum/forum/create",
    element: CreateCommunityForum,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/community-forum/topic-category",
    element: TopicCategory,
    roles: ["ADMIN"],
  },

  // Discussion Board
  {
    path: "/admin/discussion-board/discussion",
    element: DiscussionList,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/discussion-board/discussion/:id",
    element: DiscussionDetails,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/discussion-board/category-board",
    element: CategoryBoard,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/discussion-board/pending-requests",
    element: DiscusPendingRequests,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/discussion-board/pending-requests/:id",
    element: PendingRequestViewDetails,
    roles: ["ADMIN"],
  },

  //Live Messaging
  {
    path: "/admin/live-messaging",
    element: LiveMessaging,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/donation",
    element: DonationManage,
    roles: ["ADMIN"],
  },

  // training
  {
    path: "/admin/training/training-material",
    element: TrainingMaterial,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/training/training-material/add-material",
    element: AddTrainingMaterial,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/training/training-material/update/:id",
    element: AddTrainingMaterial,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/training/training-material/view/:id",
    element: TrainingMaterialView,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/training/training-category",
    element: TrainingCategory,
    roles: ["ADMIN"],
  },

  {
    path: "/admin/regional-hub",
    element: RegionalHub,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/regional-hub/list",
    element: RegionalHub,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/regional-hub/division",
    element: Division,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/regional-hub/district",
    element: District,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/division",
    element: Division,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/district",
    element: District,
    roles: ["ADMIN"],
  },

  {
    path: "/admin/notification",
    element: Notifications,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/website-cms",
    element: websiteCms,
    roles: ["ADMIN"],
  },
  {
    path: "/admin/settings",
    element: Settings,
    roles: ["ADMIN"],
  },
];

// public routers
export const publicRouters: Omit<RouteType, "roles">[] = [
  {
    path: "/admin/login",
    element: AdminLogin,
  },
  {
    path: "*",
    element: NotFound,
  },
];
